<template>
    <div class="driver-tag d-flex align-center justify-center" v-if="driver">
      <v-chip
        class="elevation-3 px-6 py-4"
        color="white"
        style="border-radius: 20px; max-width: 560px;"
        pill
        size="x-large"
      >
        <v-avatar left size="48">
          <v-img 
            :src="imageDriver"
           />
        </v-avatar>
        
        <div class="ml-4 text-left">
          <div class="text-body-1 font-weight-bold">
            {{ driver.firstName }} {{ driver.lastName }}
          </div>
          <div
            v-if="vehicleType"
            class="text-caption text-grey-darken-1 mt-1"
            style="font-weight: 700;"
          >
            {{ vehicleType }}
          </div>
        </div>
      </v-chip>
    </div>
  </template>
  
  <script>
  export default {
    name: "DriverTag",
    props: {
      driver: {
        type: Object,
        required: true,
      },
      vehicleType: {
        type: String,
        default: "",
      },
    },
    data(){
        return {
            imageDriver:require("@/assets/driver.svg")
        }
    },
    methods:{
        onImgError(event) {
            console.log(event)
            event.target.src = '/assets/no-found.png'; // your default image
        }
    }
  };
  </script>
  
  <style scoped>
  .driver-tag {
    position: fixed;
    bottom: 85px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 20;
  }
  </style>
  